export default "__VITE_ASSET__CBaRoExN__"